export default {"src":"/_next/static/media/help.95eb0947.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};